import { styled } from '@mui/material/styles'

export const UpsellContainer = styled('div', {
  name: 'UpsellContainer',
  slot: 'Root',
  skipSx: true,
})`
  display: inline;
  margin-left: 12px;
`
